import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";
import * as VO from "Data/VoiceOver";

export interface IDuckState {
    name: string;
    energy: number;
    efficiency: number;
}

export interface IDuckConfig {
    scale?: number;
    flyingSprite: string;
    flyingSprite_tired: string;
    swapSprite: string;
    swapSprite_tired: string;
    nameVO_flying: string;
    nameVO_swap: string;
}

export interface IRuntimeDuck extends IDuckState {
    readonly config: IDuckConfig;
};

const heroDuck = {name: "Ellerd", energy: 100, efficiency: 100, config: {
    flyingSprite: "Cyberchase_Duck3QEllerd_Frames_01",
    flyingSprite_tired: "Cyberchase_Duck3QEllerdTired_Frames_01",
    swapSprite: "Cyberchase_Duck3QEllerd_Frames_01",
    swapSprite_tired: "Cyberchase_Duck3QEllerdTired_Frames_01",
    scale: 0.75,
    nameVO_flying: VO.FLYING.DUCK_NAME_ELLERD, nameVO_swap: VO.SWAP.DUCK_NAME_ELLERD,
}, id: 0};

const maleDuckSprites = [{
    flyingSprite: "Cyberchase_Duck3QGenMale_Frames_01",
    flyingSprite_tired: "Cyberchase_Duck3QGenMaleTired_Frames_01",
    swapSprite: "Cyberchase_Duck3QGenMale_Frames_01",
    swapSprite_tired: "Cyberchase_Duck3QGenMaleTired_Frames_01",
}, {
    flyingSprite: "Cyberchase_Duck3QEllerd_Frames_01",
    flyingSprite_tired: "Cyberchase_Duck3QEllerdTired_Frames_01",
    swapSprite: "Cyberchase_Duck3QEllerd_Frames_01",
    swapSprite_tired: "Cyberchase_Duck3QEllerdTired_Frames_01",
}];

const femaleDuckSprites = [{
    flyingSprite: "Cyberchase_Duck3QGenFem_Frames_01",
    flyingSprite_tired: "Cyberchase_Duck3QGenFemTired_Frames_01",
    swapSprite: "Cyberchase_Duck3QGenFem_Frames_01",
    swapSprite_tired: "Cyberchase_Duck3QGenFemTired_Frames_01",
}, {
    flyingSprite: "Cyberchase_Duck3QMeeka_Frames_01",
    flyingSprite_tired: "Cyberchase_Duck3QMeekaTired_Frames_01",
    swapSprite: "Cyberchase_Duck3QMeeka_Frames_01",
    swapSprite_tired: "Cyberchase_Duck3QMeekaTired_Frames_01",
}];


const templateDucks: (IRuntimeDuck & {id: number})[] = [
    {name: "Meeka", energy: 100, efficiency: 100, config: {
        flyingSprite: "Cyberchase_Duck3QMeeka_Frames_01",
        flyingSprite_tired: "Cyberchase_Duck3QMeekaTired_Frames_01",
        swapSprite: "Cyberchase_Duck3QMeeka_Frames_01",
        swapSprite_tired: "Cyberchase_Duck3QMeekaTired_Frames_01",
        nameVO_flying: VO.FLYING.DUCK_NAME_MEEKA, nameVO_swap: VO.SWAP.DUCK_NAME_MEEKA,
    }, id: 1},
    {name: "Kevin", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_KEVIN, nameVO_swap: VO.SWAP.DUCK_NAME_KEVIN, ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 2},
    {name: "Michelle", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_MICHELLE, nameVO_swap: VO.SWAP.DUCK_NAME_MICHELLE, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 3},
    {name: "Melinda", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_MELINDA, nameVO_swap: VO.SWAP.DUCK_NAME_MELINDA, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 4},
    {name: "Jiyoung", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_JIYONG, nameVO_swap: VO.SWAP.DUCK_NAME_JIYONG, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 5},
    {name: "Aiden", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_AIDEN, nameVO_swap: VO.SWAP.DUCK_NAME_AIDEN, ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 6},
    {name: "Michael", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_MICHAEL, nameVO_swap: VO.SWAP.DUCK_NAME_MICHAEL, ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 7},
    {name: "Elliot", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_ELLIOT, nameVO_swap: VO.SWAP.DUCK_NAME_ELLIOT,  ...HLF.ArrayUtils.random(maleDuckSprites) , scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 8},
    {name: "Priya", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_PRIYA, nameVO_swap: VO.SWAP.DUCK_NAME_PRIYA, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 9},
    {name: "Diego", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_DIEGO, nameVO_swap: VO.SWAP.DUCK_NAME_DIEGO,  ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 10},
    {name: "Yolanda", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_YOLANDA, nameVO_swap: VO.SWAP.DUCK_NAME_YOLANDA, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 11},
    {name: "Drake", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_DRAKE, nameVO_swap: VO.SWAP.DUCK_NAME_DRAKE,  ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 12},
    {name: "Gilberto", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_GILBERTO, nameVO_swap: VO.SWAP.DUCK_NAME_GILBERTO,  ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 13},
    {name: "Bora", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_BORA, nameVO_swap: VO.SWAP.DUCK_NAME_BORA, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 14},
    {name: "Bob", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_BOB, nameVO_swap: VO.SWAP.DUCK_NAME_BOB,  ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 15},
    {name: "Rudy", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_RUDY, nameVO_swap: VO.SWAP.DUCK_NAME_RUDY,  ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 16},
    {name: "Squeaks", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_SQUEAKS, nameVO_swap: VO.SWAP.DUCK_NAME_SQUEAKS,  ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 17},
    {name: "Squeaks", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_SQUEAKS, nameVO_swap: VO.SWAP.DUCK_NAME_SQUEAKS, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 18},
    {name: "Hana", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_HANA, nameVO_swap: VO.SWAP.DUCK_NAME_HANA, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 19},
    {name: "Mylo", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_MYLO, nameVO_swap: VO.SWAP.DUCK_NAME_MYLO,  ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 20},
    {name: "Wendy", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_WENDY, nameVO_swap: VO.SWAP.DUCK_NAME_WENDY, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 21},
    {name: "Sherry", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_SHERRY, nameVO_swap: VO.SWAP.DUCK_NAME_SHERRY, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 22},
    {name: "Jay", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_JAY, nameVO_swap: VO.SWAP.DUCK_NAME_JAY,  ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 23},
    {name: "Sacha", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_SACHA, nameVO_swap: VO.SWAP.DUCK_NAME_SACHA,  ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 24},
    {name: "Sacha", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_SACHA, nameVO_swap: VO.SWAP.DUCK_NAME_SACHA, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 25},
    {name: "Soho", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_SOHO, nameVO_swap: VO.SWAP.DUCK_NAME_SOHO,  ...HLF.ArrayUtils.random(maleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 26},
    {name: "Soho", energy: 100, efficiency: 100, config: { nameVO_flying: VO.FLYING.DUCK_NAME_SOHO, nameVO_swap: VO.SWAP.DUCK_NAME_SOHO, ...HLF.ArrayUtils.random(femaleDuckSprites), scale: 1 - HLF.Random.floatBetween(0, 0.1)}, id: 27},
]

// tslint:disable:member-ordering
export default class GameState {
    public static totalFlyingTime = 60;
    public static restStops = [30];
    public static flyingTimeElapsed = 0;
    public static freePlay: boolean = false;

    private static readonly _ducksIHaveSeen: number[] = [];

    // badges
    public static flightCount = 0;
    public static dodgedAllObstacles = true;
    public static perfectPonds: boolean = true;
    public static swaptastic: boolean = true;
    public static get metAllTheDucks(): boolean {
        return GameState.ducksIHaveSeen.length === 28;
    }

    public static get ducksIHaveSeen(): string[] {
        const ducksById: {[id: number]: boolean} = {};
        GameState._ducksIHaveSeen.forEach((id) => ducksById[id] = true);
        console.log(ducksById);
        const dedupedDucksIHaveSeen = Object.keys(ducksById);
        return dedupedDucksIHaveSeen;
    }

    public static GetDucks(pQuantity: number): IRuntimeDuck[] {
        HLF.ArrayUtils.shuffle(templateDucks);
        templateDucks.sort((a, b) => this._ducksIHaveSeen.indexOf(a.id) ? 1 : -1);
        const ducksByName: {[name: string]: (IRuntimeDuck & {id: number})} = {};
        templateDucks.forEach(d=>ducksByName[d.name]=d);

        // No two ducks should have the same name
        const dedupedDucks = Object.keys(ducksByName).map((name)=>ducksByName[name]);

        // Ellerd needs to be part of every flock.
        const flock = [...dedupedDucks.slice(0, pQuantity-1), heroDuck]

        flock.forEach(duck => {
            this._ducksIHaveSeen.push(duck.id);
        });

        return flock;
    }
}